import 'apps/hiring/styles/components/evaluate-applicant-list.scss';
import React , { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import PropTypes from 'prop-types';
import AlertSvg from 'library/icons/alert.svg';
import AddEmployee from 'apps/hiring/components/add-employee';
import { Link } from 'library/util/core-router';
import PathSvg from 'library/icons/path.svg';
import withData from 'util/hoc/with-data';
import useShowMorePages from 'util/hoc/useShowMorePages';
import AddGroup from 'apps/hiring/components/add-group';
import PeopleList from 'apps/hiring/components/evaluate-people/people-list';

class EvaluateEmployeeList extends React.Component {
    static propTypes = {
      noMatchScore: PropTypes.bool,
      noSort: PropTypes.bool,
      onAdd: PropTypes.func,
      onMouseLeave: PropTypes.func,
      disabled: PropTypes.bool,
      onRemove: PropTypes.bool,
      onMouseOver: PropTypes.func,
      onEmployeeSelect: PropTypes.func,
      loading: PropTypes.bool,
      selectedEmployee: PropTypes.number,
      tags: PropTypes.array,
      reload: PropTypes.func,
      graph_loading: PropTypes.bool.isRequired,
      graph_data: PropTypes.any,
      graph_update: PropTypes.func,
      query: PropTypes.func.isRequired,
      parseQuery: PropTypes.func,
      pageSize: PropTypes.number,
      match: PropTypes.object,
      node_id: PropTypes.number
    }

  static defaultProps = {
    onAdd: false,
    onRemove: false,
    onMouseOver: ()=>null,
    onMouseLeave: ()=>null,
    onEmployeeSelect: ()=>null,
    selectedEmployee: null,
    disabled: false,
    tags: [],
    pageSize: 15
  }

  state = {
    sortUp: false,
    sortBy: 'match',
    sortOrder: 'desc',
    limit: 15,
    search: '',
    loading: false
  }

  onRemove = (e) => {
    if (this.props.disabled) return;
    this.props.onRemove(Number(e.target.dataset.id));
  }

  load = async () => {
    try {
      this.setState({ loading: true});
      const { data } = await this.props.query({
        limit: this.state.limit,
        name: this.state.search,
        surveyed: true,
        match: this.props.match,
        target: this.props.target
      });

      this.props.graph_update(data);

      this.setState({ loading: false});
    } catch (e) {
      console.error(e);
    }
  }

  mapEmployees = ({ id, first_name='', last_name='', match=null, assessment={} }) => (
    <div
      key={id}
      onMouseOver={()=>this.props.onMouseOver(id)}
      onClick={()=>this.props.onEmployeeSelect({id: id,assessment_id:assessment.id})}
      className={[
        'hiring-evaluate-sidebar-item',
        this.props.loading?'loading':null,
        this.props.selectedEmployee===resolve(assessment, 'id', null)?'active':null
      ].filter(c=>c).join(' ')}
    >
      {
        this.props.tags.filter(t=>t.id===id).map(t=>t.tag)
      }
      <span className="hiring-evaluate-sidebar-item-name">{ first_name }</span>
      <span className="hiring-evaluate-sidebar-item-name">{ last_name }</span>
      {
        parseInt(resolve(assessment, 'validity_score', 0)) < 100
          ? (
            <span
              data-tooltip={`${resolve(assessment, 'validity_score', 0)}% valid`}
              data-tooltip-position="top"
            >
              <AlertSvg
                className="hiring-survey-status-flag-warning"
                style={{width: '1em', height: '1em'}}
              />
            </span>
          )
          : null
      }
      <span className="hiring-evaluate-sidebar-item-match">{ match }</span>
      <span>
        <Link to={`/hiring/employee/${id}`}>
          <PathSvg />
        </Link>
      </span>
      {this.props.onRemove == false
        ? null
        : (<span className="hiring-evaluate-sidebar-item-close" data-id={id} disabled={this.props.disabled} onClick={this.onRemove}>
          ×
        </span>)
      }
    </div>
  )

  compareValue = (a,b) => {
    let comparison = 0;
    if (a.match> b.match) {
      comparison = 1;
    } else if (a.match < b.match) {
      comparison = -1;
    }
    return (
      (this.state.sortOrder === 'desc') ?
        (comparison * -1) : comparison
    );
  }

  reloadWithSortOptions = async (sortBy, sortOrder) => {
    try {
      this.setState({ loading: true });
      if(sortBy) this.setState({sortBy: sortBy});
      if(sortOrder) this.setState({sortOrder: sortOrder});
      if(sortBy !== 'match') {

        const newProps = {...this.props};
        newProps.sort_by = sortBy ? sortBy : this.state.sortBy;
        newProps.sort_order = sortOrder ? sortOrder : this.state.sortOrder;
        newProps.limit = this.state.limit;
        newProps.name = this.state.search;
        newProps.surveyed = true;
        newProps.match = this.props.match;
        const { data } = await EvaluateEmployeeList.query(null, newProps);
        this.props.graph_update(data);
      }

      this.setState({ loading: false});
    } catch (e) {
      console.error(e);
    }
  };

  setLimit = (limit) => {
    if(this.state.sortBy === 'match') this.setState({sortBy: 'first_name'}); //can't query for match stuff
    this.setState({limit: limit}, this.reloadWithSortOptions);
  }

  renderShowMorePages = () => {
    const { graph_loading, graph_data } = this.props;

    const count = Math.min(resolve(graph_data, 'users/results', []).length, this.state.limit);
    const total = resolve(graph_data, 'users/pagination/total', null);

    return useShowMorePages({
      count,
      loading: graph_loading || this.state.loading,
      total,
      setLimit: this.setLimit,
      limit: this.state.limit
    });
  }

  render() {
    const {
      onMouseLeave,
      disabled=false,
      onAdd=false,
      noSort,
      noMatchScore,
      reload,
      graph_data,
      graph_loading,
      loading,
      node_id
    } = this.props;

    const {
      sortUpMatch,
      sortUpFirstName,
      sortUpLastName
    } = this.state;

    const peopleList = resolve(graph_data, 'employees', []);
    if(this.state.sortBy === 'match') peopleList.sort(this.compareValue);

    return (
      <PeopleList
        graph_data={graph_data}
        graph_results_resolve_path='users/results'
        graph_loading={graph_loading}
        onMouseLeave={onMouseLeave}
        loading={loading}
        limit={this.state.limit}
        mapPeople={this.mapEmployees}
        handleSort={this.reloadWithSortOptions}
        peopleList={peopleList}
        currentSortColumn={this.state.sortBy}
        sortDirection={this.state.sortOrder}
        setLimit={this.setLimit}
        noMatchScore={noMatchScore}
        noSort={noSort}
      >
        { onAdd == false ?
          null:
          (
            <Fragment>
              <AddEmployee surveyed disabled={disabled} onAdd={onAdd} exclude={resolve(graph_data, 'employees', []).map(e=>e.id)} component="button" className="button-theme"/>
              <AddGroup reload={reload} node_id={node_id}/>
            </Fragment>
          )
        }
      </PeopleList>
    );
  }

}

EvaluateEmployeeList.query = async (token, { query='', limit, pageSize = 15, match, target, sort_by, sort_order }) => {
  return (
    await query({
      limit: limit ? limit : pageSize,
      surveyed: true,
      match: match,
      target: target,
      sort_by: sort_by,
      sort_order: sort_order
    })
  );
}
EvaluateEmployeeList.parseQueryData = async (data, { parseQuery=(d)=>d }) => (
  await parseQuery(data)
);

export default withData(EvaluateEmployeeList);
